<template>
  <div class="loader">
    <div class="loader__circle" :class="classObject">Loading...</div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
    },
  },
  computed: {
    classObject() {
      return {
        'loader__circle--large': this.size && this.size.toLowerCase() === 'large',
        'loader__circle--medium': this.size && this.size.toLowerCase() === 'medium',
        'loader__circle--small': this.size && this.size.toLowerCase() === 'small',
      };
    },
  },
};
</script>
